import { useMemo } from 'react';

export enum BundlingRenderTypeEnum {
  DISC = 'DISC',
  DEFAULT = 'DEFAULT',
}

export const useSvcBundlingList = () => {
  const bundlingList = useMemo(() => {
    return [
      {
        revxTypeId: 13,
        typeName: 'Bundling',
        renderType: BundlingRenderTypeEnum.DISC,
        text: 'Choose additional Bundling – Packaging options',
      },
    ];
  }, []);
  return bundlingList;
};
